





















































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    JobPageDataType,
    componentDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    FETCH_JOB_DATA
} from "../store/actions.names";
import {
    SET_JOB_CURRENT_PAGE,
    SET_JOB_DATA,
    CURRENT_PAGE_ERROR,
    SET_JOB_PARENT_PAGE
} from "../store/mutations.names";
import axios from "axios";
import TitleText from "../components/TitleText.vue";
import JobTitleInformation from "../components/JobTitleInformation.vue";
import SingleText from "../components/SingleText.vue";
import JobApplication from "../components/JobApplication.vue";
import SingleTitle from "../components/SingleTitle.vue";
import {
    globalToLocalURL
} from "../utils/common";

@Component({
    name: "JobDescriptionPage",
    components: {
        title_text: TitleText,
        JobTitleInformation,
        SingleText,
        SingleTitle,
        // title_image_richtext_list: JobCompleteCard
        // job_details_cta: JobBtn
    }
})
export default class JobDescriptionPage extends Vue {
    @Getter("jobData") public jobData!: JobPageDataType[];
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_JOB_DATA) public fetchData: any;
    @Mutation(SET_JOB_CURRENT_PAGE) public[SET_JOB_CURRENT_PAGE]: any;
    public HOST: string = HOST;
    globalToLocalURL: any = globalToLocalURL;
    public data() {
        return {
            jobheader: [],

        }
    }
    public created() {

        axios.get(`${API_URL}/others/settings/global-settings/`)
            .then(response => {
                (this as any).jobheader = response.data
            })
            .catch(e => {
                (this as any).errors.push(e)
            })

    }
    public mounted() {
        this.fetchData(this.pageData.id);

        // this.heroimganim();
        // this.smbanneranim();
        // console.log(this.jobData);
    }
}
